var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowerIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.119,
    height: 150.119,
    viewBox: "0 0 150.119 150.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shower-ic",
    transform: "translate(-1222 3170.953)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1263.748-3170.953c1.426.617,2.989.535,4.474.869a38.474,38.474,0,0,1,22.41,14.161c.711.9.595,1.2-.384,1.758-4.533,2.571-9.179,4.953-13.541,7.814-.721.473-.991.152-1.417-.3a20.878,20.878,0,0,0-11.316-6.275c-11.14-2.267-22.674,6.047-24,17.316a34.965,34.965,0,0,0-.233,4.091q.006,54-.009,107.995c0,.864.362,1.924-.845,2.391-2.863.249-5.732.066-8.6.106-2.287.032-4.576.007-6.863.007a1.217,1.217,0,0,1-1.307-.728v-111.976a2.24,2.24,0,0,0,0-1.759v-1.465a33.5,33.5,0,0,1,4.1-13.722c5.68-10.526,14.4-17.063,26.033-19.752,1.371-.317,2.8-.178,4.163-.529h2.638a3.817,3.817,0,0,0,2.345,0Z",
    transform: "translate(-0.088 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1704.733-2877.412c-.75,1.04-1.3,2.245-2.631,2.762a4.217,4.217,0,0,1-4.285-.433,41.248,41.248,0,0,1-3.918-3.267,4.369,4.369,0,0,1-.288-5.843,4.248,4.248,0,0,1,5.644-.962c2.085,1.5,4.358,2.887,5.478,5.4Z",
    transform: "translate(-332.614 -201.498)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1224.833-2660.149l15.9.023a.84.84,0,0,0-.059.263h-15.829q-.148-.088-.1-.186C1224.772-2660.115,1224.8-2660.149,1224.833-2660.149Z",
    transform: "translate(-1.931 -361.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1350.415-3170.953a2.213,2.213,0,0,1-2.345,0Z",
    transform: "translate(-89.099 0)",
    fill: "#2f2f2f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1222.124-3050a1.319,1.319,0,0,1,0,1.759Z",
    transform: "translate(-0.088 -85.479)",
    fill: "#2b2b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1222.9-2661.577l.014.286q-1.1.22-.879-.879Z",
    transform: "translate(0 -359.579)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1394.227-3071.726a20.371,20.371,0,0,1,9.859-17.02c4.412-2.76,8.993-5.261,13.576-7.734a20.989,20.989,0,0,1,28.255,7.822c1.656,2.778,1.658,2.782-1.168,4.381q-22.561,12.765-45.11,25.548c-.964.549-1.359.488-1.942-.5A23.9,23.9,0,0,1,1394.227-3071.726Z",
    transform: "translate(-121.72 -50.798)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1405.145-2993.019a5.781,5.781,0,0,1-4.71-2.665,42.762,42.762,0,0,1-2.32-4.059c-1.13-2.268-.23-4.677,2.195-6.05q13.289-7.525,26.587-15.036l31.8-17.985c3.3-1.868,5.491-1.25,7.373,2.082.335.594.676,1.184,1.01,1.779,2.266,4.027,1.4,7.117-2.665,9.423q-9.788,5.552-19.585,11.087-17.873,10.107-35.745,20.214A7.66,7.66,0,0,1,1405.145-2993.019Z",
    transform: "translate(-124.126 -92.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1491.841-2768.134c-.04-2.711,1.594-4.632,3.869-4.915a4.372,4.372,0,0,1,4.764,3.422,37.175,37.175,0,0,1,.748,4.9,4.432,4.432,0,0,1-4.033,4.716,4.458,4.458,0,0,1-4.7-3.712C1492.221-2765.3,1492.02-2766.9,1491.841-2768.134Z",
    transform: "translate(-190.708 -281.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1490.4-2849.144a4.37,4.37,0,0,1-4.263-3.521c-.291-1.431-.518-2.876-.733-4.321a4.455,4.455,0,0,1,3.522-4.98,4.41,4.41,0,0,1,5.07,3.179,39.5,39.5,0,0,1,.838,4.894A4.409,4.409,0,0,1,1490.4-2849.144Z",
    transform: "translate(-186.128 -218.314)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1623.641-2937.308c3.041,0,7.677,4.032,7.982,6.553a4.1,4.1,0,0,1-2.007,4.228,4.036,4.036,0,0,1-4.8-.093,31.926,31.926,0,0,1-3.866-3.339,4.064,4.064,0,0,1-.824-4.732A3.994,3.994,0,0,1,1623.641-2937.308Z",
    transform: "translate(-281.083 -165.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1625.753-2843.627a4.349,4.349,0,0,1,2.754-4.21,4.261,4.261,0,0,1,4.823,1.1,34.492,34.492,0,0,1,2.966,3.991,4.293,4.293,0,0,1-.9,5.572,4.288,4.288,0,0,1-5.753-.053,22.416,22.416,0,0,1-3.5-4.669A3.079,3.079,0,0,1,1625.753-2843.627Z",
    transform: "translate(-285.346 -228.137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1564.271-2798.069a4.1,4.1,0,0,1-3.625-2.53,38.9,38.9,0,0,1-1.681-4.184,4.4,4.4,0,0,1,2.573-5.5,4.355,4.355,0,0,1,5.534,2.214,36.462,36.462,0,0,1,1.731,4.315C1569.74-2800.852,1567.615-2798.038,1564.271-2798.069Z",
    transform: "translate(-237.984 -254.691)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M1563.291-2892.588c.016,2.513-1.138,4.132-2.991,4.741a4.25,4.25,0,0,1-5-1.7,36.718,36.718,0,0,1-2.278-4.063,4.389,4.389,0,0,1,1.151-5.169,4.142,4.142,0,0,1,5.264-.243A13.314,13.314,0,0,1,1563.291-2892.588Z",
    transform: "translate(-233.662 -191.597)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowerIc);
export default __webpack_public_path__ + "static/media/shower-ic.a6d6e0d45d604405da9ac662e7c49690.svg";
export { ForwardRef as ReactComponent };